import {Grid} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import BellTable from "./BellTable";
import {searchRoster} from "../../Roster/services";
import RosterTable from "./RosterTable";

export const BellTab = ({selectedSchool}) => {
    console.log("selectedSchool", selectedSchool)

    const [rosterList, setRosterList] = useState([]);

    useEffect(() => {
        fetchRosterList(selectedSchool);
    }, []);

    const fetchRosterList = async (selectedSchool) => {
        try {
            let requestDTO = {
                schoolId: Number(selectedSchool),
                code: "",
                startDate: "",
                endDate: "",
            }
            const response = await searchRoster(requestDTO)
            if (response.status === 200) {
                setRosterList(response.data)
            }
        } catch (e) {
            console.log("Error while fetching roster list e:", e);
        }
    }

    return (
        <Grid templateColumns={{sm: "1fr", xl: "repeat(3, 1fr)"}} gap="22px">
            <RosterTable
                selectedSchool={selectedSchool}
                rosterList={rosterList}
                title={"Roster"}
            />
            {rosterList && rosterList.length>0 &&
                <BellTable rosterList={rosterList}/>}
        </Grid>
    )
}